import { DialogActions, DialogContent, Typography } from "@mui/material";

import {
  Button,
  PopupDialog,
  PopupDialogTitle,
} from "~/components/design-system/index.js";

export function GmcNumberNeededDialog({
  partNumber,
  onAddGmcNumber,
  onContinue,
}: {
  partNumber: number;
  onAddGmcNumber: () => void;
  onContinue: () => void;
}) {
  return (
    <PopupDialog open={true} onClose={onContinue} testId="gmc-number-needed">
      <PopupDialogTitle
        titleText={`GMC number needed to complete Part ${String(partNumber)}`}
        closeDialog={onContinue}
      />
      <DialogContent sx={{ px: 0 }}>
        <Typography sx={{ mb: 2 }}>
          Part {partNumber} of this form must be completed by a registered
          doctor. Add your GMC number to your profile to complete it yourself.
        </Typography>
        <Typography>
          You can still view and download this form, or send it to a colleague
          who can complete it.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 0 }}>
        <Button
          label="Add GMC number"
          variant="outlined"
          onClick={onAddGmcNumber}
        />
        <Button label="Continue to form" color="primary" onClick={onContinue} />
      </DialogActions>
    </PopupDialog>
  );
}
